const config = {
  // @ts-ignore: process not found
  NODE_ENV: process.env.NODE_ENV,
}

export default config
